import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";

//import filter modal
import FilterModal from "../../components/Modal/FilterModal";

import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequestForm,
  putRequest,
  postRequestForm,
} from "../../components/Common/Utils.js";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";
import DeliveryAgents from "components/Modal/DeliveryAgents";

const filterObj = {
  first_name: "",
  last_name: "",
  gender: "",
  email: "",
  phone: "",
  country: "",
  nationality: "",
  bookingCode: "",
  bookingDate: "",
  agentEmail: "",
};

const AssignOrderList = (props) => {
  const [modal_center, setmodal_center] = useState(false);
  const [Bannerdata, setOrderdata] = useState([]);
  const [assingDeliveryModalData, setAssingDeliveryData] = useState({});
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  // const [value, setValue] = React.useState(10);
  const [sort, setsort] = React.useState("");
  const [sortOrder, setsortOrder] = React.useState("desc");
  const [sortOrderId, setsortOrderId] = React.useState(null);
  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [image, setImage] = React.useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [filter, setFilter] = useState({ ...filterObj });

  useEffect(() => {
    fetchOrderList();
  }, [currentPage]);

  useEffect(() => {
    fetchOrderList();
  }, [sort, sortOrder]);

  const GetValueOnChange = async (value, bannerId) => {

    let status = value ? false : true;

    const res = await postRequest("banner/update", { bannerId, status });

    if (res.status) {
      toast.success("Banner Status updated Successfully");
      fetchOrderList();
    } else {
      toast.error("Something went wrong");
      setLoader(false);
    }
  };
  const closeModal = () => {
    setModel(false);
  };

  const toggleModel = () => {
    console.log("toggleModel", model);
    setModel(!model);
  };

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }


  const getFilters = () => {
    const filterArgs = [];

    Object.keys(filter).forEach((key) => {
      if (
        filter[key] !== "" &&
        filter[key] !== null &&
        filter[key] !== undefined
      ) {
        var filterObject = {
          [key]: filter[key],
        };

        if (key === "title") {
          filterObject.type = "regex";
        } else if (key === "homeBlockType") {
          filterObject.type = "eq";
        } else if (key === "sizeId") {
          filterObject.type = "obj-eq";
        } else if (key === "createdAt") {
          filterObject.type = "date-eq";
        }

        filterArgs.push(filterObject);
      }
    });
    return filterArgs;
  };

  const resetFilter = () => {
    setFilter({ ...filterObj });
    toggleModel();
    fetchOrderList();
  };

  function createdAtdata(cellContent, row) {
    return (
      <React.Fragment>
        <div>
          <p>{moment(row.createdAt).format("DD-MM-YYYY")} </p>
        </div>
      </React.Fragment>
    );
  }

  function activeFormatter(cellContent, row) {
    console.log({ row });
    const isActive = row.status;
    return (
      <button
        className={`btn ${isActive ? 'btn-active' : 'btn-deactive'}`}
        type="button"
        onClick={() => GetValueOnChange(isActive, row._id)}
      >
        {isActive ? 'Published' : 'UnPublished'}
      </button>
    );
  }

  function OrderImageFormatter(cellContent, row) {
    return (
      <>
        <img
          src={row.image}
          onClick={() => showLightBox(row.image)}
          alt="Not found Banner"
          width={"50px"}
        />
      </>
    );
  }

  function ImgCoverFormatter(cellContent, row) {
    return (
      <>
        <img
          src={row.cover}
          // onClick={() => showLightBox(row.cover)}
          alt="cover img"
          width={"50px"}
        />
      </>
    );
  }
  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  const handleDownload = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = image;
    downloadLink.download = "downloaded-image.jpg";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }

  function ProductFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 justify-content-start text-center">
        {row?.userDetails &&
          <div className="flex-product gap-2">
            <h6 className="d-flex text-start"> {row?.userDetails?.first_name} {row?.userDetails?.last_name}</h6>
            <h6 className="d-flex text-start">{row?.userDetails?.email}</h6>
          </div>}
      </div>
    );
  }
  function OrderStatusFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="status-order">
          <h5 style={{
            color:
              row?.orderStatus === 'pending'
                ? '#FFC107'
                : row?.orderStatus === 'cancelled'
                  ? '#ec536c'
                  : '#4caf50', // Default color for other statuses
          }}>
            {row?.orderStatus}
          </h5>
        </div>
      </div>
    );
  }
  function PaymentStatusFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="status-order">
          <h5 style={{
            color: row?.paymentStatus === 'completed' || row?.paymentStatus === 'Paid'
              ? '#4caf50'
              : row?.paymentStatus === 'Cancelled'
                ? '#ec536c'
                : '#FFC107'
          }}>
            {row?.paymentStatus}
          </h5>
        </div>
      </div>
    );
  }
  function ShopFirstFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 justify-content-start">
        {row?.adminDetails &&
          <div className="d-flex flex-product gap-2 align-items-start">
            <img src={row?.adminDetails?.image} width='50px' />
            <div>
              <h6 className="d-flex text-start">{row?.adminDetails?.first_name} {row?.adminDetails?.last_name}</h6>
              <h6 className="d-flex text-start">{row?.adminDetails?.email}</h6>
            </div>
          </div>}
      </div>
    );
  }
  function DeliveryAgentsFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 justify-content-start">
        {row?.deliveryAgentDetails &&
          <div className="d-flex flex-product gap-2 align-items-start">
            <img src={row?.deliveryAgentDetails?.image} width='50px' />
            <div>
            <h6 className="d-flex text-start text-capitalize"
                  style={
                    row?.deliveryStatus === "cancelled"
                      ? { color: "#ec536c" }
                      : row?.deliveryStatus === "failed"
                        ? { color: "#ec536c" }
                        : row?.deliveryStatus === "pending"
                          ? { color: "#ec536c" }
                          : row?.deliveryStatus === "assigned"
                            ? { color: "rgb(255, 193, 7)" }
                            : { color: "#4caf50" }
                  }
                >{row?.deliveryStatus}</h6>
              <h6 className="d-flex text-start">{row?.deliveryAgentDetails?.first_name} {row?.deliveryAgentDetails?.last_name}</h6>
              <h6 className="d-flex text-start">{row?.deliveryAgentDetails?.email}</h6>
              <h6 className="d-flex text-start">{row?.deliveryAgentDetails?.phone}</h6>
              
           </div>
          </div>}
      </div>
    );
  }
  function TotalAmountFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="flex-product">
          ${row?.totalAmount}
        </div>
      </div>
    );
  }
  function OrderDateFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 align-items-center" style={{ whiteSpace: 'nowrap' }}>
        {moment(row.createdAt).format("DD-MM-YYYY hh:mm")}
      </div>
    );
  }

  function UserTypeFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        <div className="flex-product">
          {row?.userDetails?.type === 'user' ? <>SME</> : <>Informal Retailer</>}
        </div>
      </div>
    );
  }


  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },
    {
      text: "User Details",
      sort: false,
      formatter: ProductFormatter,
    },
    // {
    //   text: "Banner image",
    //   sort: false,
    //   formatter: OrderImageFormatter,
    // },
    //  {
    //     dataField: "_id",
    //     text: "Order Id",
    //     sort: false,
    //   },
    {
      text: "SubAdmin Details",
      sort: false,
      formatter: ShopFirstFormatter,
    },
    // {
    //   text: "User Type",
    //   sort: false,
    //   formatter: UserTypeFormatter,
    // },

    {
      // dataField: "orderStatus",
      text: "Order Status",
      sort: false,
      formatter: OrderStatusFormatter,
    },
    {
      // dataField: "orderStatus",
      text: "Payment Status",
      sort: false,
      formatter: PaymentStatusFormatter,
    },
    {
      formatter: TotalAmountFormatter,
      //dataField: "totalAmount",
      text: "Total Amount",
      sort: false,
    },
    {
      text: "Order Date",
      formatter: OrderDateFormatter,
      sort: false,
    },
    // {
    //   dataField: "actions",
    //   text: "Payment Action",
    //   formatter: PayMentFormatter,
    //   sort: false,
    // },
    {
      dataField: "actions",
      text: "Delivery AgentDetails",
      formatter: DeliveryAgentsFormatter,
      sort: false,
    },

    {
      dataField: "actions",
      text: "Action",
      formatter: iconFormatter2,
      sort: false,
    },
  ];
  const handleChange = (event) => {
    setSizePerPage(event.target.value);
    if (currentPage != 1) {
      setCurrentPage(1);
    } else {
      fetchOrderList(null, event.target.value);
    }
  };
  // const handlesorting = (event) => {
  //   setsort(event.target.value);
  // };
  const handlesortOrder = (event) => {
    setsortOrder(event.target.value);
  };
  const handleReload = () => {
    setSearchText("");
    fetchOrderList();
  };




  const cancelOrder = async (_id) => {
    const payload = {
      orderId: _id,
      orderStatus: "cancelled"
    }
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to cancel this order?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, cancel it!',
      cancelButtonText: 'No, keep it'
    });
    if (result.isConfirmed) {
      const res = await postRequest("order/admin-update-order-status", payload);
      if (res.status) {
        Swal.fire('Cancelled!', 'The order has been cancelled.', 'success');
        fetchOrderList();
      } else {
        Swal.fire('Error!', 'Something went wrong.', 'error');
        setLoader(false);
      }
    } else {
      Swal.fire('Cancelled', 'The order was not cancelled.', 'info');
    }
  };



  const PaymentOrderStatus = async (row, newStatus) => {
    console.log({ row })
    const payload = {
      orderId: row,
      paymentStatus: newStatus, // Accepts dynamic status
    };

    const confirmationMessage =
      newStatus === "Cancelled"
        ? {
          title: "Are you sure?",
          text: "Do you want to cancel this Payment?",
          confirmText: "Yes, cancel it!",
          successMessage: "The Payment has been cancelled.",
        }
        : {
          title: "Are you sure?",
          text: "Do you want to mark this order as paid?",
          confirmText: "Yes, mark as paid!",
          successMessage: "The order has been marked as paid.",
        };

    const result = await Swal.fire({
      title: confirmationMessage.title,
      text: confirmationMessage.text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: confirmationMessage.confirmText,
      cancelButtonText: "No, go back",
    });

    if (result.isConfirmed) {
      const res = await postRequest("order/update-payment-status", payload);
      if (res.status) {
        Swal.fire("Success!", confirmationMessage.successMessage, "success");
        fetchOrderList(); // Refresh the order list
      } else {
        Swal.fire("Error!", "Something went wrong.", "error");
        setLoader(false);
      }
    } else {
      Swal.fire("Cancelled", "No changes were made.", "info");
    }
  };


  function iconFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        {row?.orderStatus === 'pending' ? (
          row?.deliveryStatus === 'pending' ? (
            <>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setsortOrderId(row?._id);
                  toggleModel();
                }}
              >
                Confirm Delivery
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => cancelOrder(row?._id)}
              >
                Cancel Order
              </button>
            </>
          ) : (
            <div className="status-order">
              <h5
                style={
                  row?.deliveryStatus === "cancelled"
                    ? { color: "#ec536c" }
                    : row?.deliveryStatus === "failed"
                      ? { color: "#ec536c" }
                      : row?.deliveryStatus === "pending"
                        ? { color: "#ec536c" }
                        : row?.deliveryStatus === "assigned"
                          ? { color: "rgb(255, 193, 7)" }
                          : { color: "#4caf50" }
                }
              >
                {row?.deliveryStatus === "cancelled" || row?.deliveryStatus === "failed"
                  ? <>
                    <div>
                      <span className="text-danger text-warning-delivery">Delivery Canceled by Agent</span>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          setsortOrderId(row?._id);
                          toggleModel();
                        }}
                      >
                        Reassign Agent
                      </button>
                    </div>
                  </>
                  : <> {row?.deliveryStatus}</>
                }
              </h5>
            </div>
          )
        ) : (
          <>{row?.orderStatus === 'cancelled' ?
            <h5 style={{ color: "#ec536c" }}>{row?.orderStatus}</h5> :
            <div className="status-order">
              <h5
                style={
                  row?.deliveryStatus === "cancelled"
                    ? { color: "#ec536c" }
                    : row?.deliveryStatus === "failed"
                      ? { color: "#ec536c" }
                      : row?.deliveryStatus === "pending"
                        ? { color: "#ec536c" }
                        : row?.deliveryStatus === "assigned"
                          ? { color: "rgb(255, 193, 7)" }
                          : { color: "#4caf50" }
                }
              >
                {row?.deliveryStatus === "cancelled" || row?.deliveryStatus === "failed"
                  ? <>
                    <span className="text-danger text-warning-delivery">Delivery Canceled by Agent</span>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        setsortOrderId(row?._id);
                        toggleModel();
                      }}
                    >
                      Reassign Agent
                    </button>
                  </>
                  : <> {row?.deliveryStatus}</>
                }
              </h5>
            </div>
          }</>
        )}
      </div>
    );
  }


  function PayMentFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        {row?.paymentStatus == "Unpaid" ? (
          row?.paymentRefNumber !== "" && row?.paymentMethod == "bankDeposit" ? (
            <>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  PaymentOrderStatus(row?._id, "Paid");
                }}
              >
                Paid
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => PaymentOrderStatus(row?._id, "Cancelled")}
              >
                Cancel
              </button>
            </>
          ) : (
            <span className="text-info">
              <div className='img-rececipt-group'>
                {row?.depositProof?.map((i) => (
                  <img
                    key={i}
                    src={i}
                    width={'50px'}
                  />
                ))}
              </div>

            </span>
          )
        ) : (
          row?.paymentStatus == 'Cancelled' ?
            <span className="text-danger">Payment Cancelled</span> :
            <span className="text-success">Payment Successful</span>
        )}
      </div>
    );
  }



  function iconFormatter2(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        <button type="button" className=" btn btn-primary">
          <Link
            to={{
              pathname: `/user-order-details/${row?._id}`,
              // pathname: `/user-order-details`,
              state: { row },
            }}
          >
            <i className="fal fa-eye fs-5 text-light"></i>
          </Link>
        </button>

      </div>
    )
  }

  const limit = 10;

  const exportCSV = async () => {
    setLoader(true);

    const filterArgs = getFilters();
    const payload = {
      sortField: sort,
      sortOrder: sortOrder,
    };

    if (filterArgs?.length) {
      payload.filterArgs = filterArgs;
    } else {
      if (searchText) {
        payload.search = searchText;
      }
    }

    try {
      const response = await postRequest(`Banner/export-csv`, payload);
      const data = response.data;
      window.location.href = data.url;
      console.log("data", data);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchOrderList = async (filterArgs = [], limit = null) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      limit: limit ? limit : sizePerPageOrg,
      page: currentPage,
      sortField: sort,
      sortOrder: sortOrder,
    };

    if (filterArgs?.length) {
      payload.filterArgs = filterArgs;
    } else {
      if (searchText) {
        payload.search = searchText;
      }
    }
    try {
      const response = await postRequest(`order/assign-orders-list`, payload);
      const data = response.data;

      setTotalPage(data.count);
      setCurrentFPage(currentPage);

      console.log("table data", data.bannerData);
      setOrderdata(data?.list);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };


  const closeModalDeleveryAgent = () => {
    setModel(false);
  };

  const selectRow = (item) => {
    console.log({ item })
    setAssingDeliveryData({
      Image: item?.image,
      Title: item?.title,
      categoryId: item?._id,
      show: true
    });
    deliveryAssingOrder(item?._id);
    setModel(false);
  };

  const deliveryAssingOrder = async (_id) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      orderId: sortOrderId,
      deliveryAgentId: _id
    };
    try {
      const response = await postRequest(`order/assign-to-delivery-agent`, payload);
      if (response?.status) {
        fetchOrderList();
        // Show success message
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Order successfully assigned to the delivery agent!',
          confirmButtonText: 'OK',
          timer: 2000 // Optional: automatically close after 2 seconds
        });
      }
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };


  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <Row>
          <div className="col-md-6">
            <div className="page-title-box">
              <h4>Order Management</h4>

              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">Order Management</li>:{" "}
                <li className="breadcrumb-item">Assign Orders</li>
              </ol>
            </div>
          </div>
          <div className="col-md-6 text-end">
            {/* {canExport && (
              <button
                onClick={() => {
                  exportCSV();
                }}
                type="button"
                className="btn btn-primary mx-2"
              >
                <i class="fas fa-upload"></i> Export CSV
              </button>
            )} */}
            {/* <Link to="/createBanner">
              {" "}
              <Button>
                {" "}
                <i class="fas fa-plus"></i> Create
              </Button>{" "}
            </Link> */}
            &nbsp;&nbsp;&nbsp;
          </div>
          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={Bannerdata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <label className="mb-0 text-label">
                                    Page Size
                                  </label>

                                  <select
                                    value={sizePerPageOrg}
                                    onChange={handleChange}
                                    className="form-select"
                                    style={{ width: "7%" }}
                                  >
                                    <option value="10">10</option>

                                    <option value="20">20</option>

                                    <option value="50">50</option>
                                  </select>

                                  {/* <label className="mb-0 text-label ms-3">
                                    Sort By:
                                  </label>
                                  <select
                                    value={sort}
                                    onChange={handlesorting}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="title">Title Name</option>

                                    <option value="type">Type Name </option>
                                  </select> */}
                                  <label className="mb-0 text-label ms-3">
                                    Sort Order:
                                  </label>
                                  <select
                                    value={sortOrder}
                                    onChange={handlesortOrder}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="asc"> Ascending</option>
                                    <option value="desc">Descending</option>
                                  </select>
                                  <div className="filter-item">
                                    <input
                                      type="search"
                                      placeholder="Search"
                                      value={searchText}
                                      class="form-control"
                                      onChange={(e) =>
                                        setSearchText(e.target.value)
                                      }
                                      style={{ width: "30%" }}
                                    />
                                    <button
                                      onClick={() => {
                                        fetchOrderList();
                                      }}
                                      type="button"
                                      className="btn btn-primary mx-2"
                                    >
                                      Search
                                    </button>

                                    <button
                                      type="button"
                                      onClick={handleReload}
                                      className="btn btn-danger mx-2"
                                    >
                                      Reset
                                    </button>
                                    {/* <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button> */}
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
        {openLightbox && (
          <>
            <Lightbox
              mainSrc={image}
              onCloseRequest={() => setOpenLightBox(false)}
              toolbarButtons={[
                <button
                  className="btn btn-primary"
                  key="download"
                  onClick={handleDownload}
                >
                  Download
                </button>,
              ]}
            />
          </>
        )}

        <DeliveryAgents
          show={model}
          closeModal={closeModalDeleveryAgent}
          selectRow={selectRow} />

      </React.Fragment>
      {/* <FilterModal
        show={model}
        closeModal={closeModal}
        components={components}
      /> */}
    </>
  );
};

export default AssignOrderList;
